import ImmersalTexturedPath from '../assets/Model.glb';
//
import { HemisphericLight, Vector3 } from 'babylonjs';
import { IAssetBase } from './eyejack-web-core/src/apps/app.content';
import { AppImmersalConfig } from './eyejack-web-core/src/apps/app.immersal';
import AppImmersalWebXR from './eyejack-web-core/src/apps/app.immersal.webxr';
import ContentSimple from './content/content.simple';
import events from '../events';
import emitter from "./eyejack-web-core/src/core/events/eventemitter";
import WSBridge from './eyejack-web-core/src/core/bridge-ws/bridge.ws';
import { IS_EYEJACK_WEBXR_POLYFILL } from './eyejack-web-core/src/core/utils/utils';
import { WSBridgeCameraImageType, WSBridgeDataUpdatePolicy } from './eyejack-web-core/src/core/bridge-ws/bridge.ws.types';


export class Main extends AppImmersalWebXR {

  protected content: ContentSimple;
	private wsBridge?: WSBridge | null = null;


  constructor() {
    const renderCanvas = <HTMLCanvasElement>(document.getElementById('renderCanvas'));
    super(renderCanvas);
    //
    let configImmersal = undefined;
    configImmersal = new AppImmersalConfig({
      token: '0d9e70de2e6dad37060de2019f11f272c00fc6087fbecf803a4cffec2b24b01c',
      localizeOnDevice: false,
      maps: [
        {
          mapId: 121815,
        },
      ],
			usePoseProcessor: true,
			poseRotationConstraints: {
				rotationX: 0,
				rotationZ: 0
			}
    });
    const ajayTestMap = false;
    if( ajayTestMap ) {
      configImmersal = new AppImmersalConfig({
        token: '57dbf0a93390f6af7edffe60136d54435fc55784480ba9b40e80222a4ea2cd1e',
        localizeOnDevice: false,
        maps: [
          {
            mapId: 112879,
            binaryMapPath: ImmersalBinaryPath,
            sparseMapPath: ImmersalSparsePath,
            denseMapPath: ImmersalDensePath,
            texturedMapPath: ImmersalTexturedPath,
            pointCloudSize: 5,
          },
        ],
      });
    }
    const bethTestMap = false;
    if( bethTestMap ) {
      configImmersal = new AppImmersalConfig({
        token: '6d88dc086b63459d850767fc7550ead5ac33854db8bb289f297ac03193770cf9',
        localizeOnDevice: false,
        maps: [
          {
            mapId: 114574,
            binaryMapPath: ImmersalBinaryPath,
            sparseMapPath: ImmersalSparsePath,
            denseMapPath: ImmersalDensePath,
            texturedMapPath: ImmersalTexturedPath,
            pointCloudSize: 5,
          },
        ],
      });
    }
    this.setConfigImmersal(configImmersal);
    //
    events.on('play', () => {
      this.content.play();
    });
    events.on('stop', () => {
      this.content.stop();
    });
    emitter.on('xr-started', () => {
      this.wsCameraInit();
    })
    this.content = new ContentSimple();
  }

  private wsCameraInit() {
		if (!IS_EYEJACK_WEBXR_POLYFILL) {
      return;
    }

    if (this.wsBridge) {
      return;
    }

    this.wsBridge = new WSBridge();
    this.wsBridge.cameraDataUpdatePolicy = WSBridgeDataUpdatePolicy.Always; // None, Once or Always.
    this.wsBridge.cameraImageType = WSBridgeCameraImageType.JPEG; // JPEG or PNG.
    this.wsBridge.cameraImageScale = 0.25; // between 0.0 and 1.0
    this.wsBridge.cameraImageQuality = 0.75; // between 0.0 and 1.0
    this.wsBridge.init();
  }


  protected override initialize() {
    super.initialize();
    //
    const light = new HemisphericLight('light', new Vector3(0, 1, 0), this.scene);
    light.intensity = 0.7;
    //
    this.content.init(this.engine!, this.scene!, this.camera!);
  }

  public override render(): void {
    super.render();
    this.content.render();
  }

  public override async loadAsync() {
    await super.loadAsync();
    await this.loadContents(this.content.assets); 
  }

  protected override loadAssetComplete(asset: IAssetBase) {
    console.log('loadAssetComplete', asset.path);
    this.content.loadAssetComplete( asset );
  }
}

//----------------------------------------------------------------
const app = new Main();

app.init();